import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var WithTimestampClass;
function WithTimestamp() {
  if (WithTimestampClass === VOID) {
    class $ {
      constructor(item, at) {
        this.item_1 = item;
        this.at_1 = at;
      }
      toString() {
        return 'WithTimestamp(item=' + toString(this.item_1) + ', at=' + this.at_1.toString() + ')';
      }
      hashCode() {
        var result = this.item_1 == null ? 0 : hashCode(this.item_1);
        result = imul(result, 31) + this.at_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WithTimestamp()))
          return false;
        if (!equals(this.item_1, other.item_1))
          return false;
        if (!this.at_1.equals(other.at_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'WithTimestamp');
    WithTimestampClass = $;
  }
  return WithTimestampClass;
}
//region block: exports
export {
  WithTimestamp as WithTimestamp1a7xpvbvrfq5g,
};
//endregion

//# sourceMappingURL=WithTimestamp.mjs.map
